module.exports = __webpack_public_path__ + "static/media/react.d6bdcfb2.png";